/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RecentlySoldInventoryDTO interface.
 */
export function instanceOfRecentlySoldInventoryDTO(value) {
    return true;
}
export function RecentlySoldInventoryDTOFromJSON(json) {
    return RecentlySoldInventoryDTOFromJSONTyped(json, false);
}
export function RecentlySoldInventoryDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'inventoryId': json['inventoryId'] == null ? undefined : json['inventoryId'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'sku': json['sku'] == null ? undefined : json['sku'],
        'title': json['title'] == null ? undefined : json['title'],
        'unitsSold': json['unitsSold'] == null ? undefined : json['unitsSold'],
        'orderCount': json['orderCount'] == null ? undefined : json['orderCount'],
        'lastOrderDate': json['lastOrderDate'] == null ? undefined : (new Date(json['lastOrderDate'])),
    };
}
export function RecentlySoldInventoryDTOToJSON(json) {
    return RecentlySoldInventoryDTOToJSONTyped(json, false);
}
export function RecentlySoldInventoryDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'inventoryId': value['inventoryId'],
        'asin': value['asin'],
        'sku': value['sku'],
        'title': value['title'],
        'unitsSold': value['unitsSold'],
        'orderCount': value['orderCount'],
        'lastOrderDate': value['lastOrderDate'] == null ? undefined : ((value['lastOrderDate']).toISOString()),
    };
}
